import React from "react";
import { useTranslation } from "react-i18next";
import "./map-loader.css";

export default function MapLoader({ status }) {
  const { t } = useTranslation();
  // If status is false, we don't render anything (better for performance than hidden)
  if (!status) return null;

  return (
    <div id="map-loader">
      <div className="lds-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div className="loading-text">{t("viewer.loader.environment")}</div>
    </div>
  );
}
